<div class="mt-8 mb-4">

    @if (!isReadOnly()) {
    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-end w-full">
            <app-btn-action icon="fa fa-arrow-right-from-bracket" label="Exit"
                bgColor="bg-primary-500 hover:bg-primary-700 active:bg-primary-500"
                (clicked)="exitQuiz()"></app-btn-action>
        </div>

    </div>
    }

    <div class="flex flex-col mb-4 border-0 w-full">

        @if (!isReadOnly()) {
        <h1 class="font-semibold text-xl text-primary-500">
            Quiz Session Active - {{ quiz?.title }}
        </h1>
        }

        <div class="mt-4">
            @if (quiz) {

            @if (!isReadOnly()) {

            <div class="flex flex-row justify-between items-end w-full p-4 bg-slate-300 rounded-lg">
                <span class="text-sm text-primary-500 items-center">Question No: {{ currQuestionIndex + 1 }}/{{
                    quiz.questions?.length }}</span>
                @if (quiz.enableTimeLimit !== false) {
                <div class="flex flex-col items-center justify-center">
                    <span class="text-xl font-bold transition-colors duration-300"
                        [class.text-red-600]="remainingTime() === 0"
                        [class.text-red-500]="remainingTime() > 0 && remainingTime() <= 5"
                        [class.text-primary-500]="remainingTime() > 5"
                        [class.animate-pulse]="remainingTime() > 0 && remainingTime() <= 5">{{ formattedTimeMs() | date:
                        'mm:ss' }}</span>
                    <span class="text-xs text-primary-300">Time Remaining</span>
                </div>
                }
                @if (quiz.enableScoring !== false) {
                <span class="text-sm text-primary-500 items-center">Score: {{ userScore }}/{{ quiz.totalScore }}</span>
                }
            </div>

            @if (currentQuestion) {
            <div class="flex flex-col justify-between h-full mt-16 my-auto mx-auto">
                <h2 class="text-xl font-normal mb-4">{{ currentQuestion.questionText }}</h2>

                <!-- Multiple Choice -->
                @if (currentQuestion.questionType == questionTypesMap['multipleChoice']) {
                <div class="flex flex-col gap-2">
                    @for (opt of currentQuestion.options; track opt.id) {
                    @let isSelected = _selectedAnswerId === opt.id;
                    @let isDisabled = _isSubmitted || (quiz.enableTimeLimit !== false && remainingTime() <= 0); <button
                        (click)="!isDisabled && selectOption(opt)" [disabled]="isDisabled" [class]="isSelected 
                          ? 'bg-secondary-100 border-secondary-500 text-secondary-500' 
                          : 'bg-white border-gray-100 text-primary-300 hover:bg-gray-100 hover:text-primary-500'"
                        class="w-full text-center p-4 rounded-lg border text-base font-medium transition-all duration-200 shadow-sm disabled:opacity-50">
                        {{ opt.text }}
                        </button>
                        }
                </div>
                }

                <!-- Short Answer / Fill in the Blank -->
                @if (currentQuestion.questionType === questionTypesMap['shortAnswer'] || currentQuestion.questionType
                ===
                questionTypesMap['fillInTheBlank']) {
                <div class="mt-4">
                    <textarea rows="4" [(ngModel)]="_selectedAnswerText"
                        [disabled]="_isSubmitted || (quiz.enableTimeLimit !== false && remainingTime() <= 0)"
                        autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"
                        class="w-full p-3 border border-secondary-500 rounded-md shadow-sm resize-none focus:ring-2 focus:ring-secondary-500 disabled:bg-slate-50"
                        placeholder="Type your answer here...">
                    </textarea>
                </div>
                }

                <!-- True / False -->
                @if (currentQuestion.questionType === questionTypesMap['trueFalse']) {
                @let isDisabled = _isSubmitted || (quiz.enableTimeLimit !== false && remainingTime() <= 0); <div
                    class="flex flex-col gap-4 w-full">
                    <button (click)="!isDisabled && setTrueFalse('true')" [disabled]="isDisabled"
                        [class]="_selectedAnswerText === 'true' ? 'bg-secondary-100 text-secondary-500' : 'bg-white text-primary-300 border-gray-200'"
                        class="flex-1 titlecase text-center p-4 rounded-lg border font-semibold shadow-sm transition-all">
                        True
                    </button>
                    <button (click)="!isDisabled && setTrueFalse('false')" [disabled]="isDisabled"
                        [class]="_selectedAnswerText === 'false' ? 'bg-secondary-100 text-secondary-500' : 'bg-white text-primary-300 border-gray-200'"
                        class="flex-1 titlecase text-center p-4 rounded-lg border font-semibold shadow-sm transition-all">
                        False
                    </button>

            </div>
            }

            <div class="flex flex-row gap-4 w-full mt-16">
                @let isDisabled = ((isWorking$ | async) ?? false);
                <app-btn-action label="Skip" class="w-full"
                    bgColor="bg-transparent border-gray-200 border border-dashed hover:border-solid hover:bg-gray-100 hover:border-primary-500 active:bg-primary-500"
                    textColor="text-primary-500 disabled:text-primary-300" (clicked)="skipQuestion()" [fullWidth]="true"
                    [isDisabled]="_isSubmitted || (quiz.enableTimeLimit !== false && remainingTime() <= 0) || isDisabled">
                </app-btn-action>
                <app-btn-action label="Submit Answer" class="w-full"
                    bgColor="bg-secondary-500 disabled:bg-gray-100 hover:bg-secondary-700 active:bg-secondary-500"
                    textColor="text-white disabled:text-primary-500 hover:text-white" (clicked)="submitAnswer()"
                    [fullWidth]="true"
                    [isDisabled]="_isSubmitted || (quiz.enableTimeLimit !== false && remainingTime() <= 0) || (!_selectedAnswerId && !_selectedAnswerText) || isDisabled">
                </app-btn-action>
            </div>

        </div>
        } @else {
        <!-- Fallback loader while Firestore is resolving the stream -->
        <div class="flex flex-col items-center justify-center p-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
            <p class="text-slate-500 mt-4 text-sm">Loading your question...</p>
        </div>
        }
        } @else {
        @let answers = answersList$ | async;

        <div class="flex flex-col gap-4 h-full w-full justify-center items-center">
            @if (quiz.completed) {
            <i class="fa-solid fa-circle-check text-green-500 text-6xl mb-4"></i>
            <h2 class="text-2xl font-semibold text-primary-500">Quiz Completed!</h2>
            <span class="text-lg text-primary-300">Congratulations on successfully completing the quiz</span>
            <span class="text-lg text-primary-300">{{ quiz.title }}!</span>
            } @else {
            <i class="fa-solid fa-circle-info text-amber-500 text-6xl mb-4"></i>
            <h2 class="text-2xl font-semibold text-primary-500">Quiz Closed</h2>
            <span class="text-lg text-primary-300">This quiz session is no longer active.</span>
            <span class="text-lg text-primary-300">Viewing answers for {{ quiz.userName || 'student' }}'s attempt.</span>
            }
            @if (quiz.enableScoring) {
            <p class="text-lg text-primary-500">
                @if (isReadOnly() && quiz.userId !== user?.uid) {
                Final score is {{ quiz.userScore }} out of {{ quiz.totalScore }}.
                } @else {
                Your final score is {{ quiz.userScore }} out of {{ quiz.totalScore }}.
                }
            </p>
            }
            <div class="flex flex-row gap-2 w-full justify-center">
                <app-btn-route btnText="Return" [routeTo]="returnRoute()" [replaceUrl]="true" padding="px-16 py-2.5"
                    textStyle="text-lg" bgColor="bg-secondary-500 hover:bg-secondary-700 active:bg-secondary-500"
                    textColor="text-white"></app-btn-route>
                @if(answers?.length == 0) {
                <app-btn-action [inProgress]="(isWorking$ | async) ?? false" label="Review Answers"
                    padding="px-16 py-2.5" textStyle="text-lg"
                    bgColor="bg-primary-500 hover:bg-primary-700 active:bg-primary-500" textColor="text-white"
                    (clicked)="loadAnswers()"></app-btn-action>
                }
            </div>

            @for (item of answers; track $index) {
            <div class="flex flex-col w-full border rounded-lg bg-slate-50">
                <div class="flex flex-row justify-between bg-gray-100 items-center p-4">
                    <div class="flex flex-row items-center text-sm gap-2">
                        <h3 class="font-medium text-primary-500">Question {{ $index + 1 }}</h3>
                        <div class="h-4 w-0.5 bg-gray-300 rounded-full"></div>
                        <span class="font-light titlecase text-primary-300">{{ item.questionType | questionTypeLabel
                            }}</span>
                    </div>
                    @if (quiz.enableScoring !== false) {
                    <div class="flex item-center">
                        <h3 class="font-medium text-sm text-primary-500">Scored: {{ item.isCorrect ? item.score : 0 }}
                            of {{
                            item.score }}</h3>
                    </div>
                    }
                </div>
                <div class="flex flex-col gap-1 p-4">
                    <h3 class="font-medium text-primary-500">{{ item.questionText }}</h3>

                    <span class="text-sm {{ item.isCorrect ? 'text-green-500' : 'text-red-500' }}">Your Answer: {{
                        item.userAnswer || 'No answer provided' }}</span>
                    <span class="text-sm text-primary-300">Correct Answer: {{ getCorrectAnswer(item) }}</span>
                    <span class="font-medium text-primary-400 text-sm mt-2">Explanation:</span>
                    <p class="text-sm text-primary-300">{{ item.explanation }}</p>
                    @if(item.aiExplanation) {
                    <p class="text-sm text-primary-300">{{ item.aiExplanation }}</p>
                    }
                </div>
            </div>
            }
        </div>
        }

        } @else {
        <div class="flex flex-col items-center justify-center p-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
            <p class="text-slate-500 mt-4 text-sm">Loading Quiz...</p>
        </div>
        }
    </div>

    @if (isValidating()) {
    <div @fade class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
        <div
            class="relative w-full max-w-sm p-8 bg-white dark:bg-slate-900 rounded-3xl shadow-2xl flex flex-col items-center text-center border border-slate-100 dark:border-slate-800">
            <!-- Pulsing/Rotating Spinner -->
            <div class="relative w-24 h-24 mb-6 flex items-center justify-center">
                <div class="absolute inset-0 rounded-full bg-secondary-500/10 dark:bg-secondary-400/15 animate-ping">
                </div>
                <div
                    class="absolute inset-1.5 rounded-full border-4 border-transparent border-t-secondary-500 border-r-indigo-500 animate-spin">
                </div>
                <div
                    class="absolute inset-5 rounded-full bg-gradient-to-tr from-secondary-600 to-indigo-500 flex items-center justify-center shadow-lg">
                    <i class="fa-solid fa-wand-magic-sparkles text-white text-xl animate-pulse"></i>
                </div>
            </div>

            <!-- Typography -->
            <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">Evaluating Answer</h3>
            <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6">
                Our AI assistant is evaluating your response. This will only take a few seconds.
            </p>

            <!-- Loading Indicator -->
            <div class="w-full max-w-[180px] h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                <div
                    class="h-full w-full bg-gradient-to-r from-secondary-500 via-indigo-500 to-secondary-500 rounded-full animate-pulse">
                </div>
            </div>
            <span
                class="text-xs text-secondary-500 font-medium mt-3 tracking-wide uppercase animate-pulse">Grading...</span>
        </div>
    </div>
    }

</div>